import React from 'react';
import Table from '../../table/Table';
// import "./TwoVsTwoTable.scss";
import Score from '../../table/Score/Score';
import Options from '../../table/Options/Options';
import '../table.scss';
import { Container } from 'react-bootstrap';
function TwoVsTwoTable() {
	return (
		<Container className="tableTwo d-flex justify-content-center">
			{/*<img className="img-fluid" src={TableImage} alt="table" />*/}
			<Table twoVstwo />
			<Options />
			<Score />
			<div className="cards"></div>
		</Container>
	);
}

export default TwoVsTwoTable;
